import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterFieldValue } from '../covance-filter.models';
import { CovanceFilterBaseType } from './covance-filter-base-type';
import * as moment from 'moment';
import { isEmpty } from 'lodash';

@Injectable()
export class CovanceFilterDateType extends CovanceFilterBaseType {
    constructor(router: Router, route: ActivatedRoute) {
        super(router, route);
    }

    public serializeValue(filterValue: any): string {
        return filterValue;
    }

    public isMatch(fieldVal: FilterFieldValue, value: any) {
        if (isEmpty(value)) {
            return false;
        }

        return this.formatDateTime(value) === fieldVal.queryParamValue;
    }

    public formatDateTime(value: moment.Moment): string {
        return moment.isMoment(value) ? value.format('YYYY-MM-DD') : '';
    }

    public setValue(fieldVal: FilterFieldValue) {
        fieldVal.value = fieldVal.queryParamValue;
    }
}
